var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPaginationRight = function SvgPaginationRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 15,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 1.773 1.785 0l6.976 7.093-6.976 7.092L0 12.412l5.257-5.32L0 1.774Z",
    fill: "#163144"
  })));
};
export default SvgPaginationRight;